import type { Filter } from "@/shared/components/ResourceView";
import { OrganizationTier } from "@/shared/domain/orgs";

export interface OrgListParams {
  search?: string;
  tier?: OrganizationTier;
}

/**
 * Extracts the `name` substring and `tier` selection from the filter array
 * the DataTable produces, mapping them onto the simple query params the
 * `/v1/orgs/search` endpoint accepts. If multiple filters target the same
 * field, the last one wins — the UI shows them as separate chips in the
 * active-filters bar so the admin can see (and remove) earlier ones. The
 * match-mode toggle is ignored because the backend always joins under AND.
 */
export function filtersToParams(filters: Filter[]): OrgListParams {
  let search: string | undefined;
  let tier: OrganizationTier | undefined;

  for (const filter of filters) {
    if (filter.field === "name" && filter.type === "string") {
      const value = filter.values[0];
      if (typeof value === "string" && value.trim().length > 0) {
        search = value.trim();
      }
    } else if (filter.field === "tier" && filter.type === "enum") {
      const value = filter.values[filter.values.length - 1];
      // The filter UI exposes the enum's wire values (`free` / `premium`) as
      // raw strings; widen the comparison through the string side rather than
      // casting the enum (which `no-unsafe-enum-comparison` rejects).
      if (value === String(OrganizationTier.Premium)) {
        tier = OrganizationTier.Premium;
      } else if (value === String(OrganizationTier.Free)) {
        tier = OrganizationTier.Free;
      }
    }
  }

  return { search, tier };
}
